module.exports = __webpack_public_path__ + "img/bell_5.93db4157.jpg";